<div class="row mt-4">
  <div class="col col-xl-3">
    <!-- <mat-checkbox
      [ngClass]="{
        hilite:
          rsswa &&
          service.showAmendment &&
          rsswa.functionalTest != tmpFunctionalTest
      }"
      matTooltip="You will need to add at least one rss functional test"
      [(ngModel)]="tmpFunctionalTest"
      formControlName="chkFuncTestCtrl"
      (change)="confirmRSSFunctionalTest()"
      labelPosition="before"
    >
      RSSWA Functional Test
    </mat-checkbox> -->

    <br />
    <!-- <button
      mat-flat-button
      color="primary"
      *ngIf="
        tmpFunctionalTest &&
        (rsswa?.id ?? 0) > 0 &&
        (rsswa?.status == 1 || rsswa?.status == 6)
      "
      [disabled]="!rssFunctionalTestCreatePrivilege"
      (click)="createRSSFunctionalTest()"
    >
      Create
    </button> -->
  </div>
  <div class="col col-xl-9">
    <!-- <rss-functional-test-chips
      [placeholder]="'RSS Functional Tests'"
      [disabled]="
        !(rsswa?.status == 1 || rsswa?.status == 6) || !tmpFunctionalTest
      "
      [rssFunctionalTests]="rsswa?.rssFunctionalTests"
      [amendment]="service.showAmendment"
      (error)="showAlert($event)"
      [control]="functionalTestCtrl"
    >
    </rss-functional-test-chips> -->
    <br />
    <div class="print-container">
      <!-- <mat-form-field>
		  <mat-label
			>Testing Required Before Operation (Full Test, Functional
			Test):</mat-label
		  >

		  <textarea
			aria-label="description"
			matInput
			class="description-area"
			[(ngModel)]="tmpProvisionalTestingRequired"
			formControlName="provisionalTestingRequiredControl"
		  ></textarea>
		</mat-form-field> -->
    </div>
  </div>
</div>
